<script lang="ts">
	import type { PublicDay } from '../../AppTypes';
	import { statusFill, statusLabel, statusText } from '../../statusUtils';

	export let days: PublicDay[] = [];

	let hovered: number | null = null;
</script>

{#if days.length > 0}
	<div class="relative" on:mouseleave={() => (hovered = null)} role="img" aria-label="Daily uptime, last {days.length} days">
		<div class="flex gap-px h-9 w-full items-stretch">
			{#each days as day, i}
				<div
					class="flex-1 rounded-sm transition-opacity"
					style="background-color: {statusFill(day.status)}; opacity: {hovered !== null && hovered !== i ? 0.45 : day.status === 'unknown' ? 0.4 : 1};"
					aria-label="{day.day}: {statusLabel(day.status)}{day.uptimePercent !== null ? ` (${day.uptimePercent}% uptime)` : ''}"
					on:mouseenter={() => (hovered = i)}
				></div>
			{/each}
		</div>

		{#if hovered !== null}
			{@const d = days[hovered]}
			<div
				class="absolute bottom-full mb-2 z-10 -translate-x-1/2 pointer-events-none rounded-md bg-gray-900 text-white text-xs px-2.5 py-1.5 shadow-lg whitespace-nowrap"
				style="left: {((hovered + 0.5) / days.length) * 100}%;"
			>
				<div class="font-semibold">{d.day}</div>
				<div class="mt-0.5">
					<span class={statusText(d.status)}>{statusLabel(d.status)}</span>
					{#if d.uptimePercent !== null}<span class="text-gray-300"> · {d.uptimePercent}% uptime</span>{/if}
				</div>
			</div>
		{/if}
	</div>
{/if}
